export enum FeatureToggle {
  externalHealthDashboardFeatureToggles = 'rt_ipp_external_health_dashboard',
}
